// 自动化活动状态
export enum AutomatedStatusEnum {
  /** 异常 */
  NODEERROR = 0,
  /** 进行中 */
  ONGOING = 2,
  /** 未激活 */
  NOT_ACTIVITE = 1,
  /** 暂停中 */
  SUSPENDED = 3,
  /** 已终止 */
  TERMINATED = 4,
  /** 暂停中-节点异常 自定义的状态,不能用于其它判断，仅用于展示文案 */
  SUSPENDED_NODE_ERROR = 40,
}

export enum ActionEnum {
  /** 暂停 */
  SUSPENDED = 'suspend',
  /** 开始 */
  START = 'start',
  /** 删除 */
  DELETE = 'delete',
  /** 终止 */
  TERMINATION = 'termination',
}
